
export const APPLY_AFTERPAY_PAYMENT_METHOD = 'APPLY_AFTERPAY_PAYMENT_METHOD';
export const APPLY_AFTERPAY_REDIRECT_URL = 'APPLY_AFTERPAY_REDIRECT_URL';
export const APPLY_AFTERPAY_SESSION_ID = 'APPLY_AFTERPAY_SESSION_ID';
export const APPLY_AFTERPAY_CHECKOUT_TYPE = 'APPLY_AFTERPAY_CHECKOUT_TYPE';
export const APPLY_AFTERPAY_CHECKSUM = 'APPLY_AFTERPAY_CHECKSUM';
